import { render, staticRenderFns } from "./DetailToggle.vue?vue&type=template&id=8a65d76a&scoped=true&"
import script from "./DetailToggle.vue?vue&type=script&lang=js&"
export * from "./DetailToggle.vue?vue&type=script&lang=js&"
import style0 from "./DetailToggle.vue?vue&type=style&index=0&id=8a65d76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a65d76a",
  null
  
)

export default component.exports